function moveToTop(id, model, table) {
  if (app.movingItemToTop == true) {
    return;
  }
  moveToTopRequest(id, model, table);
}

function moveToTopRequest(id, model, table) {
  $.ajax({
    url: '/admin/request/totop',
    method: 'post',
    data: {
      id: id,
      model: model,
      table: table,
      key: $('.list-items__wrapper').attr('data-default-order-key') || 'order',
      direction: $('.list-items__wrapper').attr('data-default-order') || 'asc'
    },
    headers: {
      'X-CSRF-TOKEN': $('#csrf-token').val()
    },
    beforeSend: function () {
      app.movingItemToTop = true;
    },
    success: function (response) {
      app.movingItemToTop = false;
      if (response && response.success) {
        window.location.reload();
        return;
      }
      error();
    },
    error: function () {
      app.movingItemToTop = false;
      ajaxError();
    }
  });
}
